import { Injectable } from '@angular/core';
import { AjaxService } from './ajax.service';
import { UserDetailsService } from './user-details.service'
@Injectable()
export class ProfileSettingService {

  profileCallingQueue = [];
  constructor(
    private ajaxService:AjaxService,
    private userService:UserDetailsService
  ) { }

  getProfileData(isForce){
    if(this.userService.getUserProfileDetails() && !isForce){
      return this.userService.getUserProfileDetails();
    }else{
      return new Promise((resolve,reject)=>{
        if(this.profileCallingQueue.length > 0){
          this.profileCallingQueue.push(resolve)
        }else{
          this.profileCallingQueue.push(resolve);
          Promise.resolve(this.ajaxService.getProfileData())
          .then(profileDetails => {
            if (profileDetails) {
              this.userService.setUserProfileDetails(profileDetails);
              for(let callback in  this.profileCallingQueue){
                let resp_obj = JSON.parse(JSON.stringify(this.userService.getUserProfileDetails()));
                this.profileCallingQueue[callback](resp_obj);
              }
              this.profileCallingQueue = [];
            }
          })
        }
      })
    }


  }

}
